/**
 * KAN-615: имя-образ (persona_name) аккаунта, инлайн-редактор в ячейке аккаунта.
 * Клик открывает поле, Enter и blur сохраняют, Escape отменяет.
 */
import { InlineTextEditor } from '@/components/ui/inline-text-editor';
import type { TelegramAccount } from '@/types/telegramAccount';
import { useAccountPatch } from './useAccountPatch';

const MAX_LENGTH = 80;
const EMPTY_HINT = 'Имя в переписке не задано';
const SAVE_ERROR = 'Не удалось сохранить имя в переписке';

export function PersonaNameEditor({
  account,
}: {
  account: TelegramAccount;
}): JSX.Element {
  const key = `${account.operator_id}-${account.account_id}`;
  const current = account.persona_name ?? '';
  const save = useAccountPatch(account, SAVE_ERROR);

  return (
    <InlineTextEditor
      value={current}
      onSave={(persona_name) => save.mutate({ persona_name })}
      testId={`persona-name-${key}`}
      inputTestId={`persona-name-input-${key}`}
      errorTestId={`persona-name-error-${key}`}
      ariaLabel="Имя в переписке"
      title="Имя в переписке: нажмите, чтобы изменить"
      maxLength={MAX_LENGTH}
      emptyHint={EMPTY_HINT}
      viewClassName={`mt-0.5 text-xs ${current ? 'text-gray-700' : 'italic text-gray-500'}`}
      wrapperClassName="mt-0.5"
    />
  );
}
